import { useCallback, useState } from "react";

// Shared selection-state logic for admin list panels that support "select several rows,
// then delete them all at once" (inquiries, ad leads, documents, appointments).
export function useBulkSelect() {
  const [selected, setSelected] = useState(() => new Set());

  const toggle = useCallback((id) => {
    setSelected((s) => {
      const next = new Set(s);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  }, []);

  const toggleAll = useCallback((ids) => {
    setSelected((s) => {
      const allSelected = ids.length > 0 && ids.every((id) => s.has(id));
      return allSelected ? new Set() : new Set(ids);
    });
  }, []);

  const clear = useCallback(() => setSelected(new Set()), []);

  const isAllSelected = useCallback((ids) => ids.length > 0 && ids.every((id) => selected.has(id)), [selected]);

  return { selected, toggle, toggleAll, clear, isAllSelected };
}
